export default __webpack_public_path__ + "static/media/a017-8.18c019fe.svg";